
import {Login} from "./Login"

export function Home(){

    return(
     <div className="home-container">
        <Login/>
     </div>
    )
}